import * as C from '@/consts'
import * as a from '@/libs/a'
import logo from '@/assets/card-brands/jcb-logomark-img-01.gif'

export default {
  // ブランドコード
  code: C.BRAND_JCB,

  // ブランド判定
  match (number) {
    // 3528 - 3589
    const prefix = (number + '0000').slice(0, 4) | 0

    return a.between(prefix, 3528, 3589)
  },

  // カード番号のパターン
  pattern: [4, 4, 4, 4],

  // ロゴ
  logo
}
